import request from './request';

export const authApi = {
  getCaptcha: () => request.get('/auth/captcha'),
  login: (data) => request.post('/auth/login', data),
  register: (data) => request.post('/auth/register', data)
};

export const resourceApi = {
  getFeed: (params) => request.get('/resources/feed', { params }),
  listByBlogger: (bloggerId, params) => request.get('/resources/blogger/' + bloggerId, { params }),
  getDetail: (id) => request.get('/resources/' + id),
  like: (id) => request.post('/resources/' + id + '/like'),
  unlike: (id) => request.delete('/resources/' + id + '/like')
};

export const followApi = {
  follow: (bloggerId) => request.post('/follow/' + bloggerId),
  unfollow: (bloggerId) => request.delete('/follow/' + bloggerId),
  myFollowings: (params) => request.get('/follow/my', { params }),
  count: () => request.get('/follow/count')
};

export const paymentApi = {
  buyResource: (data) => request.post('/payment/resource-buy', data),
  getOrderStatus: (orderNo) => request.get('/payment/order/' + orderNo)
};

export const orderApi = {
  getMyOrders: (params) => request.get('/orders/my', { params }),
  getExtractCode: (id) => request.get('/orders/' + id + '/extract-code')
};
